export const NV_OFFICE_ID = "1";
export const BARODA_OFFICE_ID = "2";
